// extracted by mini-css-extract-plugin
export default {"wrapper":"W_TitleSign_wrapper__WKZMK","button":"W_TitleSign_button__-tjAC"};